import { MoveTypesEnum, OpenAPI, TenantMoveVMSingleItemResponseVM } from "@propertelligent/client-api";
import { request as __request } from "@propertelligent/client-api/core/request";

// TODO(client-api-regen): Replace with `TenantService.getApiTenantMoveFromLeaseAgreement(leaseAgreementId, moveTypeId)`
// once the backend PR merges and CI republishes the SDK with the optional `moveTypeId` query param.
export const getTenantMoveFromLeaseAgreement = (
  leaseAgreementId: number,
  moveTypeId?: MoveTypesEnum,
) =>
  __request<TenantMoveVMSingleItemResponseVM>(OpenAPI, {
    method: "GET",
    url: "/api/TenantMove/from-lease-agreement/{leaseAgreementId}",
    path: { leaseAgreementId },
    query: { moveTypeId },
  });
